import React, { useState } from "react";

import { Button, Modal, SectionCard, Stack } from "shared/ui";
import { deleteMenuAlias } from "services/aliases/rest";
import { useMenuAliases } from "shared/hooks/useMenuAliases";

import { useMenuSettingsContext } from "features/MenuSettings/context";
import { publicMenuHost } from "features/MenuSettings/lib/publicMenuHost";

import { AliasLink, AliasRow, EmptyText } from "../styles";
import { CreateAliasDialog } from "./CreateAliasDialog";

export const MenuLinkCard = () => {
    const { menuId, locale, notify } = useMenuSettingsContext();
    const { aliases, loading, setAliases } = useMenuAliases(menuId);

    const [isCreateOpen, setIsCreateOpen] = useState<boolean>(false);
    const [aliasToDelete, setAliasToDelete] = useState<string | null>(null);
    const [deleting, setDeleting] = useState<boolean>(false);

    const host = publicMenuHost();

    // Ссылки сохраняются сразу, отдельно от кнопки «Сохранить» внизу формы.
    const handleDelete = async () => {
        setDeleting(true);
        try {
            const remaining = await deleteMenuAlias(menuId, aliasToDelete);
            setAliases(remaining || []);
            setAliasToDelete(null);
        } catch (e) {
            notify.showError("Не удалось удалить ссылку", e);
        } finally {
            setDeleting(false);
        }
    };

    return (
        <SectionCard
            title="Ссылка на меню 🚀"
            description="Вставьте ссылку на меню в соцсети и на карты, и принимайте заказы онлайн."
        >
            <Stack>
                {!loading && aliases.length === 0 && (
                    <EmptyText>Пока нет ни одной ссылки</EmptyText>
                )}

                {aliases.map((item) => (
                    <AliasRow key={item.alias}>
                        <AliasLink
                            href={`${host}/${item.alias}`}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {host}/{item.alias}
                        </AliasLink>
                        <Button
                            variant="text"
                            color="danger"
                            onClick={() => setAliasToDelete(item.alias)}
                        >
                            Удалить
                        </Button>
                    </AliasRow>
                ))}

                <Button variant="outlined" onClick={() => setIsCreateOpen(true)}>
                    Добавить ссылку
                </Button>
            </Stack>

            <CreateAliasDialog
                open={isCreateOpen}
                menuId={menuId}
                locale={locale}
                onClose={() => setIsCreateOpen(false)}
                onCreated={(alias) => setAliases([...aliases, alias])}
            />

            <Modal
                open={!!aliasToDelete}
                onClose={() => setAliasToDelete(null)}
                maxWidth="xs"
                title="Удалить ссылку?"
                actions={
                    <>
                        <Button
                            variant="outlined"
                            color="neutral"
                            onClick={() => setAliasToDelete(null)}
                        >
                            Отмена
                        </Button>
                        <Button
                            variant="contained"
                            color="danger"
                            disabled={deleting}
                            onClick={handleDelete}
                        >
                            Удалить
                        </Button>
                    </>
                }
            >
                Гости перестанут открывать меню по адресу {host}/{aliasToDelete}, а QR-коды
                с этой ссылкой перестанут работать.
            </Modal>
        </SectionCard>
    );
};
